export default{
  toaster: {
    message: '',
    visible: false,
    color: ''
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/shared/states.js